import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DoubleCheckSvg = function DoubleCheckSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.707 13.952 6.498-7.448-1.05-1.004-6.498 7.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22 7-9.987 11.5-5.745-6.013 1.006-1.054 4.69 4.91 8.983-10.345zM2 12.487l1.006-1.054 4.714 4.935.445-.466 1.007 1.053-1.452 1.52z"
  }));
};
export var DoubleCheck = function DoubleCheck(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DoubleCheckSvg
  }));
};